import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, WritableSignal, signal } from '@angular/core';
import { setToolbar } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { ConfirmationService } from 'primeng/api';
import { RequestTools } from '@service/request.tools';
import { formatRequestVersion } from './../displayresult/displayresult.tools';
import { TranslateService } from '@ngx-translate/core';
import { DownloadService } from '@service/download.service';
import { catchError, from, of, tap } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'versionlist',
    templateUrl: 'versionlist.component.html',
    styleUrls: ['versionlist.component.scss'],
})
export class VersionListComponent implements OnInit, OnDestroy {
    public itemConfirm: ItemConfirmComponent;
    @Input() public editMode;
    @Input() public listVersion: WritableSignal<any[]> = signal([]);
    @Input() public docId;
    @Input() public delVer = false;
    @Input() public viewVer = false;
    @Input() public isLock = false;
    @Output() public onUpdateVer: EventEmitter<any> = new EventEmitter();
    @Output() public onViewVer: EventEmitter<any> = new EventEmitter();
    @Output() public onReadVer: EventEmitter<any> = new EventEmitter();

    public visible: boolean;
    public errorMessage = '';
    public atfName = '';
    public skeleton: boolean = true;
    public error: boolean = false;

    constructor(
        protected _messageService: MessagesService,
        private requestTools: RequestTools,
        public confirmationService: ConfirmationService,
        private translate: TranslateService,
        private downloadService: DownloadService, 
        private api: ApiV6Service
    ) {
    }

    public ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
    }

    public ngOnChanges() {
        this.initialize();        
        if (this.listVersion().length !== 0) {
            this.skeleton = false;
        } else {    
            this.returnData();
        }
    }

    public ngOnDestroy() {
        this.reset();
    }

    private initialize() {
        this.skeleton = true;
        this.error = false;
    }

    public reset() {
        this.docId = '';
        this.listVersion = signal([]);
        this.skeleton = true;
    }

    public async refresh() {
        this.initialize();        
        await this.returnData();
    }

    private returnData() {
        if (this.docId !== '') {
            return from(this.api.getVersionList(this.docId)).pipe(
                tap(result => {
                    const wVersionList = result?.['VersionList']?.['Version'] || [];
                    this.listVersion.set([...wVersionList]);
                    this.setVerName();
                    this.onReadVer.emit(this.listVersion);
                    this.error = false;
                    this.skeleton = false;
                }),
                catchError((error: any) => {
                    console.log(error);
                    this.error = true;
                    this.skeleton = true;
                    this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
                    return of(null); // Émet une valeur par défaut en cas d'erreur
                })
            ).subscribe();
        }
    }

    private setVerName() {     
        this.listVersion.update(currentVersions => {
            return currentVersions.map(item => {
                item.name = item.name.substring(5, 9);
                item.showVer = true;
                return item;
            });
          });
    }

    public refreshVer(aName) {
        this.listVersion.update(currentVersions => {
            return currentVersions.filter(item => {
              return item.Name !== aName;
            });
          });
    }

    public downloadVerFile(event, aOrigin) {
        this.execDownloadVerFile(event, aOrigin);
    }

    public async execDownloadVerFile(event, aOrigin) {
        this.downloadService.setDocId(event.Docid);
        await this.downloadService.execDownloadVerFile(event.VerFile, aOrigin);
    }

    public removeVerFile(event) {
        setToolbar();
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelV', {label: event.name}),
            () => {
                this.delete(event);
            }
        );
    }

    public showVerFile(event) {
        setToolbar();
        this.onViewVer.emit(event);
    }
   
    public async delete(aData) {
        let wRes: any;
        const wAction = {
            DelVer: aData.Docid,
            VerNum: aData.name,
        };
        const wParams = formatRequestVersion(this.docId, wAction);
        wRes = await this.requestTools.execUrlAction('setversion', wParams);        
        this.verifyResult(wRes);
        this.onUpdateVer.emit(aData.value);
    }

    private verifyResult(aResult) {
        if (aResult.Status !== undefined) {
            if (aResult.Status === 'OK') {
                aResult.status = true;
            } else {
                aResult.status = false;
            }
        }
        if (aResult.status === true) {
            this._messageService.addSuccess(this.translate.instant('Vers_Del_OK'));
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Delete_KO'));
        }
    }
}
